import Vue from 'vue'
import VueRouter from 'vue-router'
import auth from './auth'
import home from './home'
import financeiro from './financeiro'
import pedidos from './pedidos'
import tabela from './tabela'
import usuarios from './usuarios'
import errors from './errors'


Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    ...auth, 
    ...home,
    ...pedidos,
    ...financeiro,
    ...tabela,
    ...usuarios,
    ...errors,
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
